import { useQuery } from "@tanstack/vue-query";
import { type Ref } from "vue";
import { api } from "@/api";
import { type BaseReportFilters } from "./reports";

export const REPORT_COMPANION_FUNNEL_QUERY_KEY = "companion-funnel-reports";

export type CompanionFunnelReportRow = {
  siteName: string;
  totalEligible: number;
  totalSent: number;
  totalClicked: number;
  totalLoggedIn: number;
  totalRegistered: number;
  totalCheckedInCompanion: number;
  totalCompanionUsed: number;
  percentageSent: string;
  percentageClicked: string;
  percentageLoggedIn: string;
  percentageRegistered: string;
  percentageCheckedInCompanion: string;
  percentageAdopted: string;
};

export type CompanionFunnelReport = CompanionFunnelReportRow[];

export const retrieveCompanionFunnelReport = async (
  query: BaseReportFilters,
) => {
  const { body } = await api.get<CompanionFunnelReport>(
    "/reports/companion-funnel/",
    {
      query: query,
    },
  );

  return body;
};

export const useCompanionFunnelReport = (
  filters: BaseReportFilters | Ref<BaseReportFilters>,
) => {
  return useQuery({
    queryKey: [REPORT_COMPANION_FUNNEL_QUERY_KEY, filters] as const,
    queryFn: ({ queryKey: [_, query] }) =>
      retrieveCompanionFunnelReport(unref(query)),
    staleTime: 60 * 60 * 1000,
  });
};
